import React from "react";
import { Modal } from "antd";
import Dropdown from "../ui/Dropdown";

const AddQuotesModal = ({
  visible,
  onCancel,
  onSubmit,
  formData,
  setFormData,
  dropdownOptions,
  onBookChange,
}) => {
  const handleChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  const handleBookSelect = (val) => {
    handleChange("book_id", val);
    onBookChange(val);
  };

  return (
    <Modal
      title="Add Quote"
      open={visible}
      onCancel={onCancel}
      onOk={onSubmit}
      okText="Create"
      width={700}
    >
      <div className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Dropdown
            label="Book"
            options={dropdownOptions.books}
            value={formData.book_id}
            onChange={handleBookSelect}
          />
          <Dropdown
            label="Module"
            options={dropdownOptions.modules}
            value={formData.module_id}
            onChange={(val) => handleChange("module_id", val)}
          />
        </div>

        <div className="flex flex-col gap-1">
          <label className="text-xs text-gray-600 ml-2">Quote</label>
          <textarea
            value={formData.quote}
            onChange={(e) => handleChange("quote", e.target.value)}
            className="w-full px-4 py-2 border rounded-md text-sm"
            placeholder="Enter the quote..."
            style={{ height: "100px" }}
          />
        </div>
      </div>
    </Modal>
  );
};

export default AddQuotesModal;
